import Preferences from '@/creditflowresearch/domain/Preferences/Preferences';
import { PreferenceFamily } from '@/creditflowresearch/domain/Preferences/PreferenceFamily';
import {
  SOURCE_ID_MAPPINGS,
  type MappingTargetFamily,
} from '@/creditflowresearch/domain/Preferences/crossProductMappingConfig';
import { ABS_PRODUCT_ID, HYC_PRODUCT_ID, IGC_PRODUCT_ID } from '@/creditflowresearch/domain/Product/constants';
import { EMERGING_MARKET_ID } from '@/creditflowresearch/domain/Market/constants';

export { PreferenceFamily };

const CORPORATE_PRODUCT_IDS: string[] = [IGC_PRODUCT_ID, HYC_PRODUCT_ID];

const keepSelectableForFamily = (ids: string[], family: MappingTargetFamily): string[] => {
  const selectableIds = SOURCE_ID_MAPPINGS[family].map(({ id }) => id);

  return ids.filter((id) => selectableIds.includes(id));
};

export const resolvePreferenceFamily = (preferences: Preferences | null): PreferenceFamily => {
  if (!preferences) {
    return PreferenceFamily.NONE;
  }

  if (preferences.getMarketIds().includes(EMERGING_MARKET_ID)) {
    return PreferenceFamily.EM;
  }

  const productIds = preferences.getProductIds();

  if (productIds.includes(ABS_PRODUCT_ID)) {
    return PreferenceFamily.ABS;
  }

  if (productIds.some((productId) => CORPORATE_PRODUCT_IDS.includes(productId))) {
    return PreferenceFamily.CORPORATE;
  }

  return PreferenceFamily.NONE;
};

export const selectSourceIds = (
  preferences: Preferences | null,
  family: PreferenceFamily,
): string[] => {
  if (!preferences) {
    return [];
  }

  switch (family) {
    case PreferenceFamily.ABS:
      return keepSelectableForFamily(preferences.getRegionIds(), PreferenceFamily.ABS);
    case PreferenceFamily.EM:
      return keepSelectableForFamily(preferences.getRegionIds(), PreferenceFamily.EM);
    case PreferenceFamily.CORPORATE:
      return keepSelectableForFamily(preferences.getMarketIds(), PreferenceFamily.CORPORATE);
    default:
      return [];
  }
};
